import { InjectionToken } from '@angular/core';

// Prefixed onto every relative API path (`${apiBaseUrl}/v1/...`) so a real
// backend origin is one environment value away instead of an implicit
// same-origin assumption. Empty string in every environment today: MSW's
// handlers match same-origin relative paths, and no real backend origin
// exists yet (see environment.ts). Keep this '' wherever useMocks is true —
// a non-empty apiBaseUrl would make requests miss MSW's relative-path
// handlers and fail as unhandled requests instead of being mocked.
// Defaults to '' so specs get a working value without wiring a provider —
// app.config.ts's provider (from environment.apiBaseUrl) overrides it for
// the real app.
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  providedIn: 'root',
  factory: () => '',
});
